import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class NativeCheckService {
  public isNativePlatform(): boolean {
    return Capacitor.isNativePlatform() && !navigator.userAgent.includes('SznProhlizec');
  }
}
